module.exports = __webpack_public_path__ + "img/lang-11.158a7309.jpg";